// ── Adapter Supabase do IMktLeadRepository ────────────────────────
// Implementa a porta de leitura de lead do módulo MKT usando o Supabase.
// É a ÚNICA camada que conhece a query do lead completo + joins de profiles.

import { getSupabase } from '@infra/supabase/client';
import type { IMktLeadRepository, LeadFull, MktLeadEntry } from '@modules/mkt';

export class SupabaseMktRepository implements IMktLeadRepository {
  fetchLeadFull = async (leadId: string): Promise<LeadFull | null> => {
    const supabase = getSupabase();
    if (!supabase || !leadId) return null;
    const { data, error } = await supabase
      .from('leads')
      .select(`
        *,
        sdr:profiles!leads_sdr_id_fkey ( id, nome ),
        closer:profiles!leads_closer_id_fkey ( id, nome )
      `)
      .eq('id', leadId)
      .maybeSingle();
    if (error) {
      console.warn('[mktWebhook] Falha ao carregar lead:', error.message);
      return null;
    }
    return data as unknown as LeadFull | null;
  };

  // O schema mkt não é exposto ao cliente (proposital) — a RPC
  // get_lead_mkt_entries (SECURITY DEFINER) é o único caminho de leitura.
  // Ela valida o workspace por dentro; o erro sobe para o service traduzir.
  fetchLeadMktEntries = async (leadId: string): Promise<MktLeadEntry[]> => {
    const supabase = getSupabase();
    if (!supabase || !leadId) return [];
    const { data, error } = await supabase.rpc('get_lead_mkt_entries', {
      p_lead_id: leadId,
    });
    if (error) throw error;
    return (data || []) as unknown as MktLeadEntry[];
  };
}
